import React from 'react';

interface FormattedTextProps {
  text: string;
}

const FormattedText: React.FC<FormattedTextProps> = ({text}) => {
  return <span dangerouslySetInnerHTML={{__html: text}} />;
};

export default FormattedText;
